import * as angular from "angular";
import {IHttpProvider, IRequestConfig} from "angular";
import {TenantService} from "./tenantService";
import IInjectorService = angular.auto.IInjectorService;
import gatewayServer from "../gatewayServer";

export const tenantModule = angular.module("tenantModule", [])